import { axiosInstance } from './axios-instance';
import type {
  NotificationSettingsChanges,
  NotificationSettingsResponse,
} from '../types/notification-settings';

const BASE_PATH = '/admin/notification-settings';

export class NotificationSettingsService {
  static async getGlobal(): Promise<NotificationSettingsResponse> {
    const res = await axiosInstance.get<NotificationSettingsResponse>(`${BASE_PATH}/global`);
    return res.data;
  }

  static async saveGlobal(
    settings: NotificationSettingsChanges,
  ): Promise<NotificationSettingsResponse> {
    const res = await axiosInstance.put<NotificationSettingsResponse>(`${BASE_PATH}/global`, {
      settings,
    });
    return res.data;
  }

  static async getForAccount(accountId: string): Promise<NotificationSettingsResponse> {
    const res = await axiosInstance.get<NotificationSettingsResponse>(BASE_PATH, {
      params: { accountId },
    });
    return res.data;
  }

  static async saveForAccount(
    accountId: string,
    settings: NotificationSettingsChanges,
  ): Promise<NotificationSettingsResponse> {
    const res = await axiosInstance.put<NotificationSettingsResponse>(
      BASE_PATH,
      { settings },
      { params: { accountId } },
    );
    return res.data;
  }

  static async resetAccount(accountId: string): Promise<NotificationSettingsResponse> {
    const res = await axiosInstance.delete<NotificationSettingsResponse>(BASE_PATH, {
      params: { accountId },
    });
    return res.data;
  }
}
